import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Pocket, useWaffles } from '@pelotoncycle/waffles';
import { range } from 'ramda';
import React from 'react';
import { Format, toNowTime, toTime, toTimeFromString } from '@peloton/time';
import { isDefined } from '@peloton/types';
import { getFormatStringsForLocale } from '@engage/internationalize';
import { useTrackDeclinedAgeConfirmation, useTrackTappedDeclineAgeConfirmation, useTrackViewedAgeConfirmation } from '@webtv/analytics';
import { LogoutEvent, useLogout } from '@webtv/auth';
import { MediumButton } from '@webtv/buttons';
import { Copy, useCopy } from '@webtv/copy-provider';
import { engageApi } from '@webtv/data-fetch/singletons';
import { getIsTVOnline } from '@webtv/error-modal/hooks';
import { CarouselSelect } from '@webtv/inputs';
import { DateTime, useGetLocale, useLocale } from '@webtv/internationalize';
import { useRemoteControlBackButton } from '@webtv/navigation';
import { Toast } from '@webtv/notifications';
import { AppExitConfirmationModal } from '@webtv/shared-ui';
import { DeclineButton } from './DeclineButton';
import { DeclineConfirmationModal } from './DeclineConfirmationModal';
import { Header, Subheader } from './shared';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var monthFirstClass = 'month-first';
var firstYear = 1900;
export var AgeGateModalView = function AgeGateModalView(_ref) {
  var handleSubmit = _ref.handleSubmit,
      toast = _ref.toast,
      errorsEncountered = _ref.errorsEncountered;
  var locale = useLocale();
  var getLocale = useGetLocale();
  var info = getFormatStringsForLocale(locale).SLASHED_DATE;
  var isMonthFirst = info === Format.MonthFirstSlashDate;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedMonthIndex = _React$useState2[0],
      setSelectedMonthIndex = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      selectedYearIndex = _React$useState4[0],
      setSelectedYearIndex = _React$useState4[1];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      selectedDateIndex = _React$useState6[0],
      setSelectedDateIndex = _React$useState6[1];

  var datePlaceholder = useCopy('ageGate.dayPlaceholder');
  var monthPlaceholder = useCopy('ageGate.monthPlaceholder');
  var yearPlaceholder = useCopy('ageGate.yearPlaceholder');
  var today = toNowTime();
  var defaultYearIndex = today.year() - firstYear;

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      showDeclineConfirmationModal = _React$useState8[0],
      setShowDeclineConfirmationModal = _React$useState8[1];

  var firstEntryRef = React.useRef();

  var _useWaffles = useWaffles(),
      clearFocusTrap = _useWaffles.clearFocusTrap;

  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      showExitModal = _React$useState10[0],
      setShowExitModal = _React$useState10[1];

  var goBack = React.useCallback(function () {
    if (showDeclineConfirmationModal) {
      var _firstEntryRef$curren;

      clearFocusTrap((_firstEntryRef$curren = firstEntryRef.current) !== null && _firstEntryRef$curren !== void 0 ? _firstEntryRef$curren : undefined);
      setShowDeclineConfirmationModal(false);
    } else {
      setShowExitModal(true);
    }
  }, [clearFocusTrap, showDeclineConfirmationModal]);
  useRemoteControlBackButton(goBack, getIsTVOnline);
  var yearOptions = toYearOptions(defaultYearIndex);

  var _onSubmit = React.useCallback(function () {
    var selectedDate = dayOptions[selectedDateIndex !== null && selectedDateIndex !== void 0 ? selectedDateIndex : 0].value;
    var selectedMonth = toMonthOptions(getLocale)[selectedMonthIndex !== null && selectedMonthIndex !== void 0 ? selectedMonthIndex : 0].value;
    var selectedYear = yearOptions[selectedYearIndex !== null && selectedYearIndex !== void 0 ? selectedYearIndex : 0].value;
    var birthdate = toTime(new Date(selectedYear, selectedMonth, selectedDate));
    handleSubmit(birthdate);
  }, [selectedDateIndex, selectedMonthIndex, selectedYearIndex, yearOptions, getLocale, handleSubmit]);

  var monthOptions = toMonthOptions(getLocale);

  var isDateValid = function isDateValid() {
    var selectedDate = dayOptions[selectedDateIndex !== null && selectedDateIndex !== void 0 ? selectedDateIndex : 0].value;
    var selectedMonth = toMonthOptions(getLocale)[selectedMonthIndex !== null && selectedMonthIndex !== void 0 ? selectedMonthIndex : 0].value;
    var selectedYear = yearOptions[selectedYearIndex !== null && selectedYearIndex !== void 0 ? selectedYearIndex : 0].value;
    var indexMonthAtOne = selectedMonth + 1;
    var zeroPaddedMonth = indexMonthAtOne < 10 ? "0".concat(indexMonthAtOne) : indexMonthAtOne;
    var zeroPadDate = selectedDate < 10 ? "0".concat(selectedDate) : selectedDate;
    var date = toTimeFromString("".concat(selectedYear, "-").concat(zeroPaddedMonth, "-").concat(zeroPadDate));
    return date.isValid();
  };

  var dayFocusRef = React.useRef();
  var monthFocusRef = React.useRef();
  var yearFocusRef = React.useRef();
  var continueFocusRef = React.useRef();
  var declineFocusRef = React.useRef();
  var trackTappedDeclineAgeConfirmation = useTrackTappedDeclineAgeConfirmation();
  var trackDeclinedAgeConfirmation = useTrackDeclinedAgeConfirmation();

  var _useTrackViewedAgeCon = useTrackViewedAgeConfirmation(),
      _useTrackViewedAgeCon2 = _slicedToArray(_useTrackViewedAgeCon, 2),
      trackViewedAgeConfirmation = _useTrackViewedAgeCon2[0],
      pending = _useTrackViewedAgeCon2[1];

  React.useEffect(function () {
    // Only track once needed info is loaded
    if (!pending) {
      trackViewedAgeConfirmation();
    } // This should only run once for this page
    // `track` intentionally ommitted to avoid additional runs in the event that useTrack is updated
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [pending]);
  var onDeclineSelected = React.useCallback(function () {
    setShowDeclineConfirmationModal(true);
    trackTappedDeclineAgeConfirmation(errorsEncountered.length, errorsEncountered);
  }, [errorsEncountered, trackTappedDeclineAgeConfirmation]);
  var logout = useLogout(engageApi, LogoutEvent.DeclinedAgeConfirmation);
  var onConfirmDecline = React.useCallback(function () {
    trackDeclinedAgeConfirmation(errorsEncountered.length, errorsEncountered);
    logout();
  }, [trackDeclinedAgeConfirmation, errorsEncountered, logout]);
  return /*#__PURE__*/_jsxs(Container, {
    autoComplete: "off",
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      _onSubmit();
    },
    "data-test-id": "ageGateModal",
    children: [toast ? /*#__PURE__*/_jsx(Toast, {
      show: Boolean(toast),
      children: toast
    }) : null, /*#__PURE__*/_jsxs(Pocket, {
      id: "main",
      position: 0,
      vertical: true,
      children: [/*#__PURE__*/_jsx(Header, {
        children: /*#__PURE__*/_jsx(Copy, {
          id: "ageGate.header"
        })
      }), /*#__PURE__*/_jsx(Subheader, {
        children: /*#__PURE__*/_jsx(Copy, {
          id: "ageGate.subheader"
        })
      }), /*#__PURE__*/_jsx(Entries, {
        children: /*#__PURE__*/_jsxs(Pocket, {
          id: "fields",
          position: 0,
          horizontal: true,
          children: [/*#__PURE__*/_jsxs(MonthDay, {
            className: cx(isMonthFirst && monthFirstClass),
            children: [/*#__PURE__*/_jsx(Pocket, {
              id: "month",
              position: isMonthFirst ? 0 : 1,
              autofocus: isMonthFirst,
              ref: isMonthFirst ? firstEntryRef : null,
              focusRef: monthFocusRef,
              children: /*#__PURE__*/_jsx(CarouselSelect, {
                options: monthOptions,
                defaultIndex: today.month(),
                placeholderText: monthPlaceholder,
                selectedIndex: selectedMonthIndex,
                setSelectedIndex: setSelectedMonthIndex,
                focusRef: monthFocusRef,
                dataTestId: "monthEntry"
              })
            }), /*#__PURE__*/_jsx(Pocket, {
              id: "date",
              position: isMonthFirst ? 1 : 0,
              autofocus: !isMonthFirst,
              ref: isMonthFirst ? null : firstEntryRef,
              focusRef: dayFocusRef,
              children: /*#__PURE__*/_jsx(CarouselSelect, {
                options: dayOptions,
                defaultIndex: today.date() - 1,
                placeholderText: datePlaceholder,
                selectedIndex: selectedDateIndex,
                setSelectedIndex: setSelectedDateIndex,
                focusRef: dayFocusRef,
                dataTestId: "dayEntry"
              })
            })]
          }), /*#__PURE__*/_jsx(Pocket, {
            id: "year",
            position: 2,
            focusRef: yearFocusRef,
            children: /*#__PURE__*/_jsx(CarouselSelect, {
              options: yearOptions,
              defaultIndex: defaultYearIndex,
              placeholderText: yearPlaceholder,
              selectedIndex: selectedYearIndex,
              setSelectedIndex: setSelectedYearIndex,
              focusRef: yearFocusRef,
              dataTestId: "yearEntry"
            })
          })]
        })
      }), isDefined(selectedDateIndex) && isDefined(selectedMonthIndex) && isDefined(selectedYearIndex) && isDateValid() ? /*#__PURE__*/_jsx(Pocket, {
        id: "continue",
        position: 1,
        focusRef: continueFocusRef,
        children: /*#__PURE__*/_jsx(ContinueButton, {
          dataTestId: "continueButton",
          handleClick: _onSubmit,
          focusRef: continueFocusRef,
          children: /*#__PURE__*/_jsx(Copy, {
            id: "ageGate.continue"
          })
        })
      }) : /*#__PURE__*/_jsx(ContinueButton, {
        dataTestId: "disabledContinueButton",
        children: /*#__PURE__*/_jsx(Copy, {
          id: "ageGate.continue"
        })
      }), /*#__PURE__*/_jsx(Pocket, {
        id: "decline",
        position: 2,
        focusRef: declineFocusRef,
        children: /*#__PURE__*/_jsx(DeclineButton, {
          dataTestId: "declineButton",
          handleClick: onDeclineSelected,
          focusRef: declineFocusRef
        })
      })]
    }), showDeclineConfirmationModal ? /*#__PURE__*/_jsx(DeclineConfirmationModal, {
      errorsEncountered: errorsEncountered,
      handleCancel: function handleCancel() {
        var _firstEntryRef$curren2;

        clearFocusTrap((_firstEntryRef$curren2 = firstEntryRef.current) !== null && _firstEntryRef$curren2 !== void 0 ? _firstEntryRef$curren2 : undefined);
        setShowDeclineConfirmationModal(false);
      },
      handleConfirm: onConfirmDecline
    }) : null, showExitModal && /*#__PURE__*/_jsx(AppExitConfirmationModal, {
      handleResume: function handleResume() {
        var _firstEntryRef$curren3;

        clearFocusTrap((_firstEntryRef$curren3 = firstEntryRef.current) !== null && _firstEntryRef$curren3 !== void 0 ? _firstEntryRef$curren3 : undefined);
        setShowExitModal(false);
      }
    })]
  });
};

var toYearOptions = function toYearOptions(defaultYearIndex) {
  return range(0, defaultYearIndex + 1).map(function (i) {
    return {
      value: firstYear + i,
      displayName: "".concat(firstYear + i)
    };
  });
};

var dayOptions = range(0, 31).map(function (i) {
  return {
    value: i + 1,
    displayName: "".concat(i + 1)
  };
});

var toMonthOptions = function toMonthOptions(getLocale) {
  return range(0, 12).map(function (i) {
    return {
      value: i,
      displayName: DateTime.toMonthNameShort(toTime(new Date(2022, i, 1)), getLocale)
    };
  });
};

var Container = /*#__PURE__*/styled("form")({
  name: "Container",
  class: "ctb3uqb"
});
var Entries = /*#__PURE__*/styled("div")({
  name: "Entries",
  class: "e1grkk6z"
});
var MonthDay = /*#__PURE__*/styled("div")({
  name: "MonthDay",
  class: "m41hova"
});
var ContinueButton = /*#__PURE__*/styled(MediumButton)({
  name: "ContinueButton",
  class: "cgcoxnd"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/age-gate/AgeGateModalView.linaria.module.css");